module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 115.023bec65.png";